import * as React from 'react';

interface CpanelLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: 16 | 20 | 24;
}

/**
 * cPanel circular brand mark. Uses the official orange (#FF6C2C) but the
 * inner glyph keeps `currentColor` so the mark adapts when rendered inside
 * tinted backgrounds (e.g. on a primary orange button).
 */
function CpanelLogo({ size = 20, className, ...rest }: CpanelLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="cPanel"
      className={className}
      {...rest}
    >
      <circle cx="16" cy="16" r="16" fill="#FF6C2C" />
      <path
        fill="#fff"
        d="M16.4 9.5a6.5 6.5 0 0 0-6.3 4.9l1.7.4A4.7 4.7 0 0 1 16.4 11h2.4a2.4 2.4 0 0 0 0 4.8h-1.5l.5-1.7h-1.4a3.4 3.4 0 1 0 0 6.8h2a3.4 3.4 0 0 0 3.3-2.4l-1.7-.5a1.6 1.6 0 0 1-1.6 1.2h-2a1.6 1.6 0 0 1 0-3.2h1.5a4.2 4.2 0 0 0 0-8.4Z"
      />
    </svg>
  );
}

export { CpanelLogo };
export type { CpanelLogoProps };
